'use client'

import React, { useEffect, useState } from 'react'
import { CopilotWithoutTailwind as CopilotWithOutAnimation } from './copilot'

interface ChatbotProps {
  fabTop?: number
  fabCompact?: boolean
}

const Chatbot = ({ fabTop, fabCompact }: ChatbotProps) => {
  const copilotEventHandler = (e: any) => {
    switch (e.data.type) {
      case 'copilot-iframe-loaded':
        break

      case 'copilot-agent-callback-init':
        break

      case 'join-conversation':
        break

      case 'copilot-agent-callback-success':
        console.log('copilot-agent-callback-success', e.data)
        break

      case 'copilot-iframe-open':
        break

      case 'copilot-iframe-close':
        break

      default:
    }
  }

  useEffect(() => {
    window.addEventListener('message', copilotEventHandler)
    return () => {
      window.removeEventListener('message', copilotEventHandler)
    }
  }, [])

  // Use absolute URL for localhost development, relative for production
  const [iframeUrl, setIframeUrl] = useState('/p/acko-assist-v2/chat?journey=auto-presales&scope=auto-explore')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname
      const isLocalhost =
        hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        hostname.startsWith('192.168.') ||
        hostname.startsWith('10.')
      const baseUrl = isLocalhost ? 'https://www.ackodev.com' : ''
      const url = `${baseUrl}/p/acko-assist-v2/chat?journey=auto-presales&scope=auto-explore`
      console.log('Chatbot iframe URL:', url, 'hostname:', hostname, 'isLocalhost:', isLocalhost)
      setIframeUrl(url)
    }
  }, [])

  return <CopilotWithOutAnimation url={iframeUrl} fabHide={false} onEvent={() => {}} zIndex={500} bottom={16} top={fabTop} fabCompact={fabCompact} />
}

export default Chatbot
